export default {
  bookExperiencePanel: 'Panou de rezervare experiență',
  calendarIcon: 'Pictogramă calendar',
  coverImageForResource: 'Imagine de copertă pentru experiențele {{title}}',
  filterBy: 'Filtrează după {{filter}}',
  filterByDateRange: 'Filtrează după interval de date',
  gallery: 'Galerie',
  goBack: 'Înapoi la pagina anterioară',
  hostUserIcon: 'pictogramă utilizator gazdă',
  imageOf: 'Imagine {{title}}',
  interactiveMapAltText: 'Hartă interactivă cu {{title}} selectabile',
  mediaSlides: 'Diapozitive media',
  muteVideo: 'Dezactivează sunetul videoclipului',
  nextPhoto: 'Fotografia următoare',
  noVideoPlayback: 'Nu există capacitate de redare video',
  pauseVideo: 'Pauză videoclip',
  photoOf: 'fotografie a {{name}}',
  playVideo: 'Redare videoclip',
  previousPhoto: 'Fotografia anterioară',
  moreFiltersAndExperiences: 'Mai multe filtre și experiențe',
  reserveSelectedSlot: 'Rezervă intervalul selectat',
  reviewRating: 'Evaluare recenzie {{rating}} din 5',
  overallReviewRating: 'Evaluare generală a recenziilor {{rating}} din 5',
  selectCountryCodeForPhoneNumber:
    'Selectează codul țării pentru numărul de telefon',
  selectDate: 'Selectează data',
  selectParticipants: 'Selectează participanții',
  selectSessionTime: 'Selectează ora sesiunii',
  unmuteVideo: 'Activează sunetul videoclipului',
  viewShoppingCart: 'Vizualizează coșul de cumpărături',
  itemsInCart: '{{count}} articole în coșul de cumpărături',
  zoomIn: 'Mărește',
  zoomOut: 'Micșorează',
  selectData: 'Selectează {{data}}',
  reserveName: 'Rezervă {{name}}',
  deleteReservation: 'Șterge rezervarea {{experienceTitle}}',
  editParticipantsFor: 'Editează participanții pentru {{experienceTitle}}',
  enterPromoCode: 'Introdu codul promoțional',
  applyPromoCode: 'Aplică codul promoțional',
  increaseAddOnAmount: 'Crește cantitatea de {{addOn}} selectată',
  decreaseAddOnAmount: 'Scade cantitatea de {{addOn}} selectată',
  addOnModal: 'Fereastră {{addOn}}',
  moreInformationAboutAddOn: 'Mai multe informații despre {{addOn}}',
  decreasePriceTierTickets: 'Scade biletele {{priceTier}}',
  increasePriceTierTickets: 'Crește biletele {{priceTier}}',
  downloadFilename: 'Descarcă {{filename}}',
  viewFullDetailsDescription: 'Vizualizează descrierea completă a detaliilor',
  viewFullDescription: 'Vizualizează descrierea completă',
  closeModal: 'Închide fereastra',
  hyattBanner: 'Banner exclusiv pentru membrii World Of Hyatt',
  hyattBannerDesc:
    'Banner promoțional care indică beneficiile și ofertele exclusive disponibile membrilor programului de loialitate World of Hyatt',
  previousSlide: 'Diapozitivul anterior',
  nextSlide: 'Diapozitivul următor',
  paginationBulletMessage: 'Mergi la diapozitivul',
  exitFullscreen: 'Ieși din vizualizarea pe ecran complet',
  enterFullscreen: 'Intră în vizualizarea pe ecran complet',
  videoSlide: 'Diapozitiv video',
  imageSlide: 'Diapozitiv imagine',
  of: 'din',
  noDescription: 'Fără descriere',
  mediaGallery: 'Carusel - Galerie media',
  dateSelector: 'Selector de dată',
  nextWeek: 'Săptămâna următoare',
  previousWeek: 'Săptămâna precedentă',
  scheduleAgenda: 'Agenda programului',
  scheduleNav: 'Navigare program',
  scheduleViewSelector: 'Selector vizualizare program',
  selectedDateAriaLabel: '{{date}}, selectat',
  tapToBookExperience: 'Rezervați {{title}}',
  bookExperienceAriaLabel: 'Rezervați {{title}}',
  joinWaitlistAriaLabel: 'Înscrieți-vă pe lista de așteptare pentru {{title}}',
};
